<!--
 * @Author: QWX
 * @Description:
 * @LastEditors: QWX
 * @LastEditTime: 2021-11-26 18:30:51
-->
<template>
  <zl-dialog class="zl-saas" v-loading="loading" title="文件预览" ref="dialog" width="60%" :close-on-click-modal="false">
    <el-image
      v-if="isImg"
      :style="{ width: '100%' }"
      :src="imgUrl"
    >
    </el-image>
    <zl-pdf
      v-else
      style="height:600px"
      ref="zlPdf"
      :url="url"
      :file-name="file"
    />
  </zl-dialog>
</template>
<script>
import store from '@/store'
import config from '@/config/config'
export default {
  data() {
    return {
      fileName: '',
      file: '',
      url: '',
      loading: false,
      isImg: false,
      imgUrl: ''
    }
  },
  created() {
    let path = window.location.pathname
    if (window.location.pathname.indexOf('/index.html') !== -1) {
      path = window.location.pathname.replace('/index.html', '')
    }
    if (window.location.pathname.indexOf('/smallScale.html') !== -1) {
      path = window.location.pathname.replace('/smallScale.html', '')
    }
    this.url = window.location.origin + path
  },
  methods: {
    async open(args) {
      this.fileName = args.name
      const fileType = args.name.substring(args.name.lastIndexOf('.') + 1)
      this.isImg = ['png', 'jpg', 'gif', 'jpeg'].includes(fileType.toLocaleLowerCase())
      this.loading = true
      store
        .dispatch('getFileToken', {
          type: 2,
          bindType: 1,
          bindGuid: args.guid
        })
        .then((res) => {
          this.loading = false
          const url = `${config.fileDownUrl}/zsj-file-server/token/downloadFile?guid=${args.guid}&token=${res.data}`
          this.file = encodeURIComponent(url)
          this.imgUrl = url
          console.log('file', this.file)
        })
      return this.$refs.dialog.open()
    }
  }
}
</script>
<style lang="scss">

</style>
